import React, { useState } from 'react';
import { Button, ButtonGroup, Container, Fade } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import SubNavigation from './SubNavigation';

const propTypes = {
  title: PropTypes.string,
  links: PropTypes.arrayOf(Object),
  buttons: PropTypes.arrayOf(Object),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
const defaultProps = {
  title: '',
  links: [],
  buttons: [],
  children: null,
};

export default function Contents(props) {
  const [fadeIn, setFadeIn] = useState(false);
  const { links, title, buttons, children } = props;
  setTimeout(() => setFadeIn(true), 300);

  return (
    <>
      {links.length > 0 && <SubNavigation links={links} title={title} />}
      {!fadeIn && (
        <p className="text-muted text-center mt-3" data-testid="Text-loading">
          <FontAwesomeIcon icon={faSpinner} spin pulse /> Loading...
        </p>
      )}
      <Fade in={fadeIn}>
        <div>
          <div className="d-flex mb-3">
            <h2 className="page-content-header mb-0">{title}</h2>
            {buttons.length > 0 && (
              <div className="flex-grow-1 d-flex align-content-center align-items-center justify-content-end  text-end">
                <ButtonGroup size="sm">
                  {buttons.map((b, index) => (
                    <Button
                      variant="outline-primary"
                      key={`pi-btn-group-item-${index.toString()}`}
                      onClick={b.click}
                      data-testid="Button"
                    >
                      {b.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            )}
          </div>
          <Container fluid className="outlet px-0">
            {children}
          </Container>
        </div>
      </Fade>
    </>
  );
}

Contents.propTypes = propTypes;
Contents.defaultProps = defaultProps;
